/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */

/**
 * theming declaration (Note: does not match with material-ui theme)
 */
export const theme = {
  colors: {
    primary: '#008EDE',
    secondary: '#31C0FD',
    tertiary: '#000000',

    text: '#D2D2D2',
    accent: '#81D1FF',

    white: '#ffffff',
    black: '#000000',
    grey: '#4D4D4D',
    greyMedium: '#595959',
    greyLight: '#d2d2d2',
    bluelight: '#D8EBF6',

    background: '#000000',
    error: '#f52a2a',
    warning: '#ffcc00',
  },
};
